/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 09:17:34
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-11 10:23:48
 * @name: api接口基类
 * @Description: api接口基类
 * @FilePath: \preSaleNafterSaleBackstage\src\api\apiBase.js
 * @Author: DESKTOP-1QU67QM
 */
import cookie from '@/storage/cookie'; //cookie对象
import { Message } from 'element-ui';
const apiBase = class apiBase {
  constructor() {

  }
  /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: api请求公共方法
     */
  base(instance) {
    instance.defaults.baseURL = process.env.VUE_APP_BASE_API;
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 请求拦截添加公共参数
     */
    instance.interceptors.request.use(config => {
      const token = new cookie().getToken();
      token && (config.headers.Authorization = token);
      config.timeout = 8000;
      return config;
    })
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 回传拦截处理回传内容
     */
    instance.interceptors.response.use(response => {
      let res = { code: response.data.code, msg: response.data.msg, data: response.data.data };
      if (res.code === 200) {
        return res;
      } else if (res.code === 401) {
        new cookie().removeToken();
        location.reload();
      } else {
        return Promise.reject(res);
      }
    }, error => {
      error = JSON.parse(JSON.stringify(error));
      if(error?.response) {
        console.error(err);
      } else {
        Message.error(error.message);
      }
      return Promise.reject(error);
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: get方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   * @param {Function} callback 回调函数
   */
  get(url, data, instance) {
    this.base(instance);
    return instance.get(url, { params: data });
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: post方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   * @param {Function} callback 回调函数
   */
  post(url, data, instance) {
    instance.interceptors.request.use(config => {
      config.headers.Accept = 'application/json';
      config.headers['Content-Type'] = 'application/json';
      return config;
    });
    this.base(instance);
    return instance.post(url, data);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出错误
   * @param {Object} instance 待挂载实例
   */
  alertError(instance) {
    instance.interceptors.response.use(response => {
      return response;
    }, error => {
      Number(error.code) && Message.error(error.msg);
      return Promise.reject(error);
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出成功
   * @param {Object} instance 待挂载实例
   */
  alertSuccess(instance) {
    instance.interceptors.response.use(response => {
      Message.success(response.msg);
      return response;
    }, error => {
      return Promise.reject(error);
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出结果msg
   * @param {Object} instance 待挂载实例
   */
  alertMessage(instance) {
    this.alertSuccess(instance);
    this.alertError(instance);
  }
}

export default apiBase;